module.exports = __webpack_public_path__ + "ff55bd9cfae3b98f9192526e7cbf6402.jpg";